import { Trans, t } from "@lingui/macro";
import RecoverySourceConfirmDrawer from "./RecoverySourceConfirmDrawer";

type RecoveryDeviceChangeDrawerProps = {
  // Undefined when the current device can't be named: not in this phone's list, or another phone's
  // device whose name the cloud couldn't give.
  currentDeviceName?: string;
  newDeviceName: string;
  // The current device is set up on another phone, which stops using it (TAJ-1641).
  currentOnAnotherPhone?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Confirmation before one Apple Health device replaces another as the HRV source: the switch re-imports
// the last 90 days of recovery data. Copy from product (Ed, TAJ-1524), reworded for HRV (TAJ-1628). When
// the current device is another phone's, the same copy says where it is, without the line about scores
// (TAJ-1641).
const RecoveryDeviceChangeDrawer = ({
  currentDeviceName,
  newDeviceName,
  currentOnAnotherPhone = false,
  onConfirm,
  onCancel,
}: RecoveryDeviceChangeDrawerProps) => (
  <RecoverySourceConfirmDrawer
    title={<Trans>Changing HRV device</Trans>}
    body={
      currentOnAnotherPhone
        ? currentDeviceName
          ? t`Your HRV data will now come from ${newDeviceName} instead of ${currentDeviceName}, which is set up on another iPhone. We'll re-import your last 90 days of recovery data, which may take a little while.`
          : t`Your HRV data will now come from ${newDeviceName} instead of your current device, which is set up on another iPhone. We'll re-import your last 90 days of recovery data, which may take a little while.`
        : currentDeviceName
          ? t`Your HRV data will now come from ${newDeviceName} instead of ${currentDeviceName}. We'll re-import your last 90 days of recovery data, which may take a little while. My Readiness scores you already have won't be recalculated.`
          : t`Your HRV data will now come from ${newDeviceName} instead of your current device. We'll re-import your last 90 days of recovery data, which may take a little while. My Readiness scores you already have won't be recalculated.`
    }
    confirmLabel={<Trans>Change HRV device</Trans>}
    cancelLabel={<Trans>Cancel</Trans>}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default RecoveryDeviceChangeDrawer;
